<template>
    <div>
        <div class="home--offers">
            <common-content-spacer height="medium">
                <common-grid-items v-if="offers?.length">
                    <offer-card-component
                        v-for="offer in offers"
                        :key="offer.id"
                        :redirectionType="'details'"
                        :offer="offer"
                        @location-click="locationClicked"
                    ></offer-card-component>
                </common-grid-items>
                <div v-else>
                    {{ $t('forms.user.profile.messages.no_favorite_offers') }}
                </div>
            </common-content-spacer>
        </div>
    </div>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import OfferCardComponent from 'components/page-elements/offer/OfferCardComponent'
    export default {
        components: { OfferCardComponent },

        data() {
            return {
                isLoading: false,
                offers: [],
            }
        },

        methods: {
            getFavoritesOffers() {
                this.isLoading = true
                OfferAPI.getFavorites().then((res) => {
                    this.offers = res.map((item) => item.offer)
                    this.isLoading = false
                })
            },
            locationClicked(location) {
                window.open(`https://www.google.com/maps/place/${location.lat},${location.lng}`, '_blank')
            },
        },

        mounted() {
            this.getFavoritesOffers()
        },
    }
</script>
